import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { postMessageApi } from "../../apis/message";
import { handleApiError } from "../../helpers";
import { MessagePayload } from "../../interfaces/message";
import FormData from "form-data";

const createMultiPartFormData = (payload: MessagePayload) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(payload)) {
    formData.append(key, value);
  }
  return formData;
};

export const useSendMessage = () => {
  const [submitting, setSubmitting] = useState(false);

  const postMessage = useCallback(async (payload: MessagePayload) => {
    try {
      setSubmitting(true);
      const headers = {
        "Content-type": "multipart/form-data",
      };
      const finalPayload = createMultiPartFormData(payload);
      const { data } = await postMessageApi(finalPayload, headers);

      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      toast.error(handleApiError(error));
    }
  }, []);

  return { submitting, postMessage };
};
